import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import AdminHeader from '../Header/AdminHeader';
import AdminFooter from '../Footer/AdminFooter';
import AdminLeftMenu from '../Navbar/AdminLeftMenu';
import { userloginDetails } from '../Utils/AdminAuth';
import Error from '../Dashboard/Error';
import { HOST_URL } from '../Dashboard/api/Api';
class ChangeCurrency extends Component {

    constructor() {

        const lStorage = userloginDetails();
        const userId = lStorage?.user?.userId;
        const userToken = lStorage?.token;
        const isAdmin = lStorage?.user?.isAdmin;
        const permissionsubadmin = lStorage?.permission?.per_value?.usermanagement?.children

        super();

        this.state = {
            user_id: userId,
            token: userToken,
            userType: isAdmin,
            permissionsubadmin: permissionsubadmin,
            successMessage: false,
            ChangeCurrencyAlert: false,
            deleteWord: '',
            seletedUserId: '',
            selectedUserType: '',
            errorMessage: '',
            bgColor: "alert alert-success alert-dismissible",
        }
    }

    componentDidMount() {
        this.getUserDetails();
        this.setState({ seletedUserId: this.props.match.params.id, selectedUserType: this.props.match.params.userType });
    }

    ChangeCurrency() {
        document.querySelector("body").scrollTo(0, 0);

        if (this.state.deleteWord === "delete") {
            fetch(`${HOST_URL}/convert_currency_user.php`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user_id: this.state.user_id,
                    method: "changecurrency",
                    ret_user_id: this.props.match.params.id,
                    token: this.state.token,
                }),
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.success === true) {
                        this.setState({
                            successMessage: true,
                            bgColor: "alert alert-success alert-dismissible",
                            errorMessage: result.message,
                        });

                        this.props.history.push(
                            "/admin/change-currency/" + this.props.match.params.id
                        );
                    } else {
                        this.setState({
                            successMessage: true,
                            bgColor: "alert alert-danger alert-dismissible",
                            errorMessage: result.message,
                        });
                    }
                })
                .catch((error) => {
                    console.error("Error changing currency:", error);
                });
        } else {
            this.setState({
                successMessage: true,
                bgColor: "alert alert-danger alert-dismissible",
                errorMessage: "Please type Delete word to change the currency",
            });
        }
    }

    getUserDetails() {
        this.setState({ seletedUserId: this.props.match.params.id });

        fetch(`${HOST_URL}/admin_user_list.php`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                user_id: this.state.user_id,
                method: "retrieve",
                type: "userdetails",
                ret_user_id: this.props.match.params.id,
                token: this.state.token,
            }),
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.success === true) {
                    this.setState({
                        email: result.data[0].email,
                    });
                } else {
                    this.setState({
                        successMessage: true,
                        successBg: "alert alert-danger alert-dismissible",
                        errorMessage: result.message,
                    });
                }
            })
            .catch((error) => {
                console.error("Error fetching user details:", error);
            });
    }


    alertCurrency() {
        this.setState({
            ChangeCurrencyAlert: true
        })
    }



    render() {
        return (
            <>
                {this.state.userType === "reseller" ? <Error /> :
                    <div className="wrapper">
                        <AdminLeftMenu />
                        <div className="main">
                            <AdminHeader />
                            <main className="content">
                                <div className="container-fluid p-0">
                                    <div className="row mb-2 mb-xl-3">
                                        <div className="col-auto d-none d-sm-block">
                                            <h3>User Details <strong className='text-info'> {this.state.email} </strong>  </h3>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="card">


                                            <div className="card-header">
                                                <h5 className="card-title mb-0">
                                                    <div >
                                                        <nav className="text-center" aria-label="breadcrumb">
                                                            <ol className="breadcrumb bg-transparent p-0 mt-1 mb-0">

                                                                <Link to={'/admin/user-details/' + this.state.seletedUserId + `/` + this.state.selectedUserType}><li className="breadcrumb-item">User Details </li> </Link>


                                                                {(this.state.userType === "admin" || this.state.userType === "reseller" || this.state.userType === "emp" || (this.state.userType === "subadmin" && this.state.permissionsubadmin.transactiondetails)) && <Link to={'/admin/user-transaction-details/' + this.state.seletedUserId + `/` + this.state.selectedUserType}>
                                                                    <li className="breadcrumb-item"> Transaction Details </li></Link>}

                                                                {(this.state.userType === "admin" || this.state.userType === "reseller" || this.state.userType === "emp" || (this.state.userType === "subadmin" && this.state.permissionsubadmin.addeditprice)) &&
                                                                    <Link to={'/admin/user-price-details/' + this.state.seletedUserId + `/` + this.state.selectedUserType + `?` + "channel=whatsapp"}>
                                                                        <li className="breadcrumb-item"> Add Price </li></Link>}

                                                                {(this.state.userType === "admin" || (this.state.userType === "subadmin" && this.state.permissionsubadmin.transactiondetails)) &&
                                                                    (<Link to={'/admin/aws-settings/' + this.state.seletedUserId + `/` + this.state.selectedUserType + `?` + "channel=whatsapp"}>
                                                                        <li className="breadcrumb-item"> AWS Settings </li></Link>
                                                                    )}

                                                                {(this.state.userType === "admin" || (this.state.userType === "subadmin" && this.state.permissionsubadmin.billingmode)) && (
                                                                    <Link to={"/admin/user-billing-mode/" + this.state.seletedUserId + `/` + this.state.selectedUserType} >
                                                                        {" "} <li className="breadcrumb-item">{" "} Billing Mode{" "} </li>
                                                                    </Link>
                                                                )}

                                                                {(this.state.userType === "admin" || this.state.userType === "reseller" || this.state.userType === "emp" || (this.state.userType === "subadmin" && this.state.permissionsubadmin.addeditcredit)) &&
                                                                    <Link to={'/admin/user-add-price/' + this.state.seletedUserId + `/` + this.state.selectedUserType}>  <li className="breadcrumb-item "> Add Credit </li></Link>}

                                                                {(this.state.userType === "admin" || (this.state.userType === "subadmin" && this.state.permissionsubadmin.entitybypass)) &&
                                                                    <Link to={'/admin/user-entity-pass/' + this.state.seletedUserId + `/` + this.state.selectedUserType}>  <li className="breadcrumb-item"> Entity By Pass   </li></Link>}

                                                                {(this.state.userType === "admin" || (this.state.userType === "subadmin" && this.state.permissionsubadmin.changecurrency)) &&
                                                                    <Link to={'/admin/change-currency/' + this.state.seletedUserId + `/` + this.state.selectedUserType}>  <li className="breadcrumb-item active"> Change Currency  </li></Link>}

                                                                {(this.state.userType === "admin" || (this.state.userType === "subadmin" && this.state.permissionsubadmin.bulksmsroutesetting)) &&
                                                                    <Link
                                                                        to={
                                                                            "/admin/bulk-sms-route/" +
                                                                            this.state.seletedUserId + `/` + this.state.selectedUserType
                                                                        }
                                                                    >
                                                                        {" "}
                                                                        <li className="breadcrumb-item ">
                                                                            {" "}
                                                                            Bulk Sms Route Setting{" "}
                                                                        </li>
                                                                    </Link>}

                                                                {(this.state.userType === "admin" || (this.state.userType === "subadmin" && this.state.permissionsubadmin.autoshorturl)) &&
                                                                    <Link
                                                                        to={`/admin/api-auto-short-url/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                                                    >
                                                                        <li className="breadcrumb-item">
                                                                            Auto Short URL
                                                                        </li>
                                                                    </Link>}

                                                                {/* {this.state.userType === "admin" &&
                                                                    <Link
                                                                        to={`/admin/extra-settings/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                                                    >
                                                                        <li className="breadcrumb-item">
                                                                            Extra Settings
                                                                        </li>
                                                                    </Link>} */}
                                                                {(this.state.userType === "admin" || (this.state.userType === "subadmin" && this.state.permissionsubadmin.extrasettings)) &&
                                                                    <Link
                                                                        to={`/admin/extra-settings/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                                                    >
                                                                        <li className="breadcrumb-item">
                                                                            Extra Settings
                                                                        </li>
                                                                    </Link>}

                                                                {(this.state.userType === "admin" || (this.state.userType === "subadmin" && this.state.permissionsubadmin.mmlite)) &&
                                                                    <Link
                                                                        to={`/admin/mmlite/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                                                    >
                                                                        <li className="breadcrumb-item">
                                                                            MMLite
                                                                        </li>
                                                                    </Link>}
                                                                {(this.state.userType === "admin" || (this.state.userType === "subadmin" && this.state.permissionsubadmin.ai_bot)) &&
                                                                    <Link
                                                                        to={`/admin/ai-bot/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                                                    >
                                                                        <li className="breadcrumb-item">
                                                                            AI Bot
                                                                        </li>
                                                                    </Link>}

                                                                {(this.state.userType === "admin" || (this.state.userType === "subadmin" && this.state.permissionsubadmin.edituserplan)) &&
                                                                    <Link
                                                                        to={`/admin/edit-user-plan/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                                                    >
                                                                        <li className="breadcrumb-item">
                                                                            Edit User Plan
                                                                        </li>
                                                                    </Link>}

                                                                {/* {this.state.userType === "admin" &&
                                                                    <Link
                                                                        to={`/admin/ivr-setting/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                                                    >
                                                                        <li className="breadcrumb-item">
                                                                            IVR Setting
                                                                        </li>
                                                                    </Link>} */}
                                                            </ol>
                                                        </nav>
                                                    </div>
                                                </h5>
                                            </div>

                                            <div className="card-body">


                                                {
                                                    this.state.successMessage ?
                                                        <div className={this.state.bgColor} role="alert">
                                                            <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                                <span aria-hidden="true">×</span>
                                                            </button>
                                                            <div className="">
                                                                {this.state.errorMessage}
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                }


                                                <div className="filter-option">

                                                    <div className="row">

                                                        {this.state.ChangeCurrencyAlert ?
                                                            <>
                                                                <div className="col-md-12 mb-3 text-left">
                                                                    <p>Please Type delete word Into text Box </p>
                                                                    <div className="input-group mb-2 mr-sm-2">

                                                                        <input onChange={(event) => this.setState({ deleteWord: event.target.value })} type="text" placeholder="delete" className="form-control" />
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-4 text-center">
                                                                    <div className="input-group mb-2 mr-sm-2">
                                                                        <input type="button" onClick={() => this.ChangeCurrency()} value="Confirm to change INR ot EUR" className="btn btn-block btn-danger" />
                                                                    </div>
                                                                </div>
                                                            </>

                                                            :

                                                            <div className="col-md-4 text-center">
                                                                <div className="input-group mb-2 mr-sm-2">
                                                                    <input type="button" onClick={() => this.alertCurrency()} value="Change Currency INR to EUR" className="btn btn-block btn-danger" />
                                                                </div>
                                                            </div>

                                                        }



                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </main>
                            <AdminFooter />
                        </div>
                    </div>
                }</>);
    }
}

export default ChangeCurrency;